import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../../../componentes/modal/modal";
import Button from "../../../../componentes/button/button";
import Input from "../../../../componentes/input/input";
import ProdutoCatalogoService from "../../../../services/resource/produtoCatalogoService";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";

const produtoCatalogoService = new ProdutoCatalogoService();

const optionsMedida = [
    { value: 'UN', label: "Unidade" },
    { value: 'KG', label: "Quilograma" },
    { value: 'LT', label: "Litro" }
]

const inicial = {
    nome: "",
    descricao: "",
    unidadeMedida: "",
    categoria: "",
    observacoes: "",
};

/**
 * Cadastro rápido de produto a partir do autocomplete da Etapa 1 — só os campos sugeridos no
 * pedido. Dados complementares podem ser ajustados depois na tela de administração de Produtos.
 */
export default function CadastrarProdutoCatalogoModal({ isOpen, onClose, nomeInicial, onCriado }) {
    const [form, setForm] = useState(inicial);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (isOpen) setForm({ ...inicial, nome: nomeInicial || "" });
    }, [isOpen, nomeInicial]);

    function set(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    function salvar() {
        if (!form.nome.trim()) {
            toast.error("Informe o nome do produto.");
            return;
        }

        setSalvando(true);
        produtoCatalogoService.salvar({
            nome: form.nome.trim(),
            descricao: form.descricao,
            unidadeMedida: form.unidadeMedida,
            categoria: form.categoria,
            observacoes: form.observacoes,
        })
            .then(res => {
                toast.success("Produto cadastrado com sucesso.");
                onCriado(res.data);
            })
            .catch(error => {
                const mensagem = error?.response?.data?.message || "Erro ao cadastrar produto.";
                toast.error(mensagem);
            })
            .finally(() => setSalvando(false));
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Cadastrar Produto"
            subtitle="Cadastro rápido — dados complementares podem ser ajustados depois em Produtos."
            className="w-[90%] max-w-xl"
            footer={
                <div className="flex justify-end gap-2">
                    <Button variant="outline" label="Cancelar" onClick={onClose} disabled={salvando} />
                    <Button variant="blue" label="Salvar" iconLeft="fa fa-check" loading={salvando} onClick={salvar} />
                </div>
            }
        >
            <div className="p-3 py-4 flex flex-col gap-4">
                <Input label="Nome do Produto" required value={form.nome} onChange={e => set("nome", e.target.value)} autoFocus />
                <Input label="Descrição" value={form.descricao} onChange={e => set("descricao", e.target.value)} />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <CustomDropdown
                        options={optionsMedida}
                        optionValue="value"
                        optionLabel="label"
                        label="Unidade de Medida"
                        value={form.unidadeMedida}
                        onChange={e => set("unidadeMedida", e.value)}
                        placeholder="Ex: UN, CX, KG"
                    />
                    <Input label="Categoria" value={form.categoria} onChange={e => set("categoria", e.target.value)} />
                </div>
                <Input label="Observações" value={form.observacoes} onChange={e => set("observacoes", e.target.value)} />
            </div>
        </Modal>
    );
}
